import React, { useState } from 'react';
import { deliveryCheck } from '../utils/delivery';
import './PostcodeChecker.css';

// Postcode delivery checker. Takes a 4-digit postcode and reports which of the
// three delivery zones it falls in. Pass `onResult(result|null)` to react to
// changes (used by checkout to gate Zone 3). Optional `initial` seeds the field.
export default function PostcodeChecker({ onResult, initial = '', compact = false }) {
  const [pc, setPc] = useState(String(initial).replace(/\D/g, '').slice(0, 4));
  const [result, setResult] = useState(() => {
    const seed = String(initial).replace(/\D/g, '').slice(0, 4);
    return seed.length === 4 ? deliveryCheck(seed) : null;
  });

  const handle = (val) => {
    const digits = val.replace(/\D/g, '').slice(0, 4);
    setPc(digits);
    const r = digits.length === 4 ? deliveryCheck(digits) : null;
    setResult(r);
    if (onResult) onResult(r);
  };

  return (
    <div className={`pcc ${compact ? 'pcc--compact' : ''}`}>
      <label className="pcc-label" htmlFor="pcc-input">Check delivery to your postcode</label>
      <div className="pcc-row">
        <input
          id="pcc-input"
          className="pcc-input"
          type="text"
          inputMode="numeric"
          pattern="\d*"
          maxLength={4}
          placeholder="e.g. 3029"
          value={pc}
          onChange={(e) => handle(e.target.value)}
          aria-describedby="pcc-result"
        />
      </div>
      {result && result.zone && (
        <p id="pcc-result" className={`pcc-result pcc-result--zone${result.zone}`} role="status">
          {result.message}
        </p>
      )}
    </div>
  );
}
